import { useParams } from "react-router-dom";
import AssetView from "@/custolink-views/asset_frontend/asset_view/AssetView";

export default function AssetDefaultView() {
  const { serialNumber } = useParams();

  return (
    <AssetView
      serialNumber={serialNumber ?? ""}
      customAssetView={{
        urlSlug:"",
        assetAttrValue: "",
      }}
    />
  );
}
